import { prefixObjectValues as pre } from '../../../utils';
const prefix = 'phone-table';
const table = pre(
  {
    addPhoneNum: 'add-btn',
    phoneRow: 'row-',
    phoneTypeRow: 'type-',
    phoneCountryCode: 'countryCode-',
    phoneNumberRow: 'phoneNumber-',
  },
  prefix
);

export default table;
